import { createStore } from 'vuex'

export default createStore({
  state: {
    // Onboarding seleccionado para edición desde el reporte
    onboardingToEdit: null,
  },
  getters: {
    onboardingToEdit: (state) => state.onboardingToEdit,
  },
  mutations: {
    setOnboardingToEdit(state, onboarding) {
      state.onboardingToEdit = onboarding;
    },
    clearOnboardingToEdit(state) {
      state.onboardingToEdit = null;
    },
  },
  actions: {
    setOnboardingToEdit({ commit }, onboarding) {
      commit('setOnboardingToEdit', onboarding);
    },
    clearOnboardingToEdit({ commit }) {
      commit('clearOnboardingToEdit');
    },
  },
  modules: {
  }
})
